<script lang="ts">
    import NewBookmark from "./NewBookmark.svelte"
    import { href, Views } from "../../../utils/Constant/Constant";
    import data from "../../../Data/Bookmarks/Bookmarks.json"
    import Link from "svelte-link";
    import {bookmarkId} from "../../../store"
    import Tags from "./Tags.svelte";
    function handleTab(id:string){
        bookmarkId.update(value => value = id)
    }
</script>
<ul class="nav main-menu" role="tablist">
    <NewBookmark />
    <li class="nav-item">
      <span class="main-title"> {Views}</span>
    </li>
    {#each data.bookmarkbtndata as bookmarkItem}
        <li>
            <Link class="show"  id={bookmarkItem.id}  href={href} role="tab" on:click={()=>handleTab(bookmarkItem.id)} >
                <span class="title">{bookmarkItem.name}</span>
            </Link>
        </li>
    {/each}
    <li>
      <hr>
    </li>
    <Tags />
    {#each data.bookmarkdata as bookmarkItem}
        <li>
            <Link class="show" id={bookmarkItem.id} href={href} role="tab" on:click={()=>handleTab(bookmarkItem.id)}>
                <span class="title"> {bookmarkItem.name}</span>
            </Link>
        </li>
    {/each}
</ul>